import { observer } from "mobx-react-lite";

import ChooseEntityDialog from "@/components/ChooseEntityDialog";
import { ChooseEntityDialogTriggerSize } from "@/components/ChooseEntityDialog/types";
import { Entity, EntityType } from "@/queries";

interface SelectTemplateProps {
  template?: Partial<Entity<EntityType.PROMPT | EntityType.SNIPPET>>;
  onSelect: (template: Entity<EntityType.PROMPT | EntityType.SNIPPET>) => void;
  sourceTemplateId?: number | null;
  isSnippet?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  isLoading?: boolean;
  onCreateNew?: () => void;
  onEditPrompt?: () => void;
  url?: string;
  selectLatest?: boolean;
  allowDuplicateVariants?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  size?: ChooseEntityDialogTriggerSize;
}

function SelectTemplate({
  template,
  onSelect,
  isSnippet = false,
  disabled = false,
  readonly,
  isLoading = false,
  onCreateNew,
  selectLatest = true,
  allowDuplicateVariants = false,
  onEditPrompt,
  hasError,
  errorMessage,
  url,
  size,
}: SelectTemplateProps) {
  const selectedEntity: Entity | undefined = template
    ? ({
        ...template,
        type: isSnippet ? EntityType.SNIPPET : EntityType.PROMPT,
        path: [],
      } as Entity)
    : undefined;

  const isReadonlyState = readonly ?? disabled;

  return (
    <div className="w-full overflow-hidden">
      <ChooseEntityDialog
        config={{
          selectLatest,
          allowDuplicateVariants,
        }}
        type={isSnippet ? EntityType.SNIPPET : EntityType.PROMPT}
        onSelect={onSelect as (entity: Entity) => void}
        selectedEntity={selectedEntity}
        hasError={hasError}
        errorMessage={errorMessage}
        currentFolderId={template?.folder_id ?? null}
        readonly={isReadonlyState}
        isLoading={isLoading}
        onInlineCreate={onCreateNew}
        onInlineEdit={onEditPrompt}
        url={url}
        size={size}
      />
    </div>
  );
}

export default observer(SelectTemplate);
